import { LendingOverview } from "@/features/treasury/treasury";

export default function TreasuryLendingPage() {
  return <LendingOverview />;
}
